<script>
import Layout from "../../layouts/main";
import Heading from "../../layouts/heading";
// import CategoryCard from "@/components/cards/CategoryCard";
import appConfig from "@/app.config";
import api from "../../../api";

export default {
  page: {
    title: "Network",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Heading,
    //  CategoryCard
  },
  computed: {
    sortedCat() {
      return this.prioritizeMemberPractices(this.categoriesList);
    },
  },
  data() {
    return {
      pcns: null,
      categoriesList: [],
      categories: [],
      networkCmsId: null,
      page: {
        title: "Network",
        lastUpdated: "31 Dec 2020 15:00",
        addNewBtn: false,
        deleteBtn: false,
        activeBtn: false,
        submitBtn: false,
      },
      // categories: [
      //   {
      //     name: "Meetings & Events",
      //     additionalProp1: {
      //       icon: 'meetings-events-icon.svg',
      //       link: "/pages/meetings-events"
      //     }
      //   },
      //   {
      //     name: "Meeting Minutes",
      //     additionalProp1: {
      //       icon: 'pcn-staff-icon.svg',
      //       link: "/pages/meetings-minutes"
      //     }
      //   },
      //   {
      //     name: "News",
      //     additionalProp1: {
      //       icon: 'pcn-staff-icon.svg',
      //       link: "/pages/pcn-news-edit"
      //     }
      //   },
      //    {
      //     name: "Video",
      //     additionalProp1: {
      //       icon: 'pcn-staff-icon.svg',
      //       link: "/pages/video"
      //     }
      //   },
      //   {
      //     name: "Member Practices",
      //     additionalProp1: {
      //       icon: 'pcn-staff-icon.svg',
      //       link: "/pages/member-practices"
      //     }
      //   },
      //   {
      //     name: "FAQs",
      //     additionalProp1: {
      //       icon: 'pcn-staff-icon.svg',
      //       link: "/pages/faqs"
      //     }
      //   },
      // ]
    };
  },
  methods: {
    prioritizeMemberPractices(data) {
      return data.sort((a, b) => {
        if (a.name === "Member Practices") return -1;
        if (b.name === "Member Practices") return 1;
        return 0;
      });
    },
    updateCurrentCategory(val) {
      this.$store.commit("updateCurrentCategory", val);
    },
    sleep(seconds) {
      return new Promise((resolve) => setTimeout(resolve, seconds * 1000));
    },
    getCategories() {
      if (this.currentCms && this.currentCms.id) {
        var url = "/api/cms/" + this.currentCms.id + "/categories";
        api
          .get(url)
          .then((response) => {
            var objIndex = response.data.findIndex(
              (obj) => obj.name == "Pages (Footer)"
            );
            if (objIndex != -1) {
              response.data[objIndex].name = "Info Pages";
            }
            this.categories = response.data;
          })
          .catch((e) => {
            this.categories = [];
            console.log(e);
          });
      }
    },
    getPcnWithRels() {
      if (
        this.currentPractice &&
        Object.prototype.hasOwnProperty.call(this.currentPractice, "pcnId")
      ) {
        api
          .get(`/api/pcns/${this.currentPcn.id}/practice-data`)
          .then((response) => {
            api
              .get(`/api/practice-data/${response.data.id}/cms`)
              .then((response2) => {
                this.networkCmsId = response2.data.id;
                api
                  .get(`/api/cms/${response2.data.id}/categories`)
                  .then((response3) => {
                    this.categoriesList = response3.data;
                  })
                  .catch((e) => {
                    console.log(e);
                  });
              })
              .catch((e) => {
                console.log(e);
              });
          })
          .catch((e) => {
            console.log(e);
          });
      } else {
        this.categoriesList = [];
      }
    },
    isStaffCategory() {
      let val = false;
      let staffCats = [
        "Meeting & Events",
        "PCN News",
        "PCN Mail Settings",
        "PCN Insights",
        "PCN Events",
        "PCN Social Media",
        "Alerts",
        "Videos",
        "FAQs",
      ];
      for (const item of staffCats) {
        let exists = this.categoriesList.find((x) => x.name == item);
        if (exists) val = true;
      }
      return val;
    },
  },
  watch: {
    currentPcn() {
      this.getPcnWithRels();
    },
  },
  async mounted() {
    await this.getPcnWithRels();
    await this.getCategories();
  },
};
</script>

<template>
  <Layout>
    <Heading :page="page"></Heading>
    <div class="pl-page-container pt-0">
      <!-- <div
        v-if="
          this.currentPractice.name == 'Demo' &&
          categories.length &&
          categories.find((x) => x.name == 'Global Update')
        "
      >
        <div class="font-size-20 font-weight-medium mt-4">Network Update</div>
        <div class="row p-0 mt-4" style="letter-spacing: 0.02em">
          <div
            class="col-md-2"
            v-for="item in categories"
            v-bind:key="`${item.id}1`"
            :to="item.link"
            @click="updateCurrentCategory(item)"
            v-show="item.name == 'Global Update'"
          >
            <router-link
              :to="{
                name: 'Dynamic Network Category Page',
                params: {
                  categoryId: item.id,
                  cmsId: item.cmsId,
                  categoryName: item.name.replace(/ /g, '').toLowerCase(),
                },
              }"
              class="text-dark"
            >
              <div class="card align-items-center">
                <div
                  v-if="item.additionalProp1.beta"
                  class="w-100 mt-3"
                  style="margin-bottom: -2.5em; z-index: 1"
                >
                  <span
                    class="p-1 px-2 text-light"
                    style="
                      background-color: #f28d00;
                      font-size: 11px;
                      font-weight: 500;
                    "
                    >BETA</span
                  >
                </div>
                <div
                  v-if="item.additionalProp1.coming_soon"
                  class="w-100 mt-3"
                  style="margin-bottom: -2.5em; z-index: 1"
                >
                  <span
                    class="p-1 px-2 text-light"
                    style="
                      background-color: #333;
                      font-size: 11px;
                      font-weight: 500;
                    "
                    >COMING SOON</span
                  >
                </div>
                <div
                  v-if="item.additionalProp1.new"
                  class="w-100 mt-3"
                  style="margin-bottom: -2.5em; z-index: 1"
                >
                  <span
                    class="p-1 px-2 text-light"
                    style="
                      background-color: #b60000;
                      font-size: 11px;
                      font-weight: 500;
                    "
                    >NEW</span
                  >
                </div>
                <div class="card-body p-0">
                  <div class="text-primary font-size-50">
                    <span v-if="item.additionalProp1.icon">
                      <img
                        v-if="item.additionalProp1.icon.endsWith('.svg')"
                        :src="
                          require(`@/assets/images/${item.additionalProp1.icon}`)
                        "
                      />
                      <i v-else :class="item.additionalProp1.icon"></i>
                    </span>
                  </div>
                </div>
                <div class="card-body p-0 pb-3 pt-2 text-center">
                  <p class="mx-auto text-uppercase m-0 font-weight-medium">
                    {{ item.name === 'Meeting & Events' ? 'Events' : item.name }}
                  </p>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div> -->
      <div v-if="categoriesList.length">
        <div class="font-size-20 font-weight-medium mt-4">PCN Pages</div>
        <div class="row p-0 mt-4" style="letter-spacing: 0.02em">
          <div
            class="col-md-2"
            v-for="item in sortedCat"
            v-bind:key="`${item.id}0`"
            :to="item.link"
            @click="updateCurrentCategory(item)"
            v-show="
              item.name == 'PCN Overview' ||
              item.name == 'PCN Team' ||
              item.name == 'PCN Services' ||
              item.name == 'PCN Self Referrals' ||
              item.name == 'Extended Hours' ||
              item.name == 'Documents' ||
              item.name == 'Member Practices' ||
              item.name == 'Partner Organisations'
            "
          >
            <router-link
              :to="{
                name: 'Dynamic Network Category Page',
                params: {
                  categoryId: item.id,
                  cmsId: item.cmsId,
                  categoryName: item.name.replace(/ /g, '').toLowerCase(),
                },
              }"
              class="text-dark"
            >
              <div class="card align-items-center">
                <div
                  v-if="item.additionalProp1.beta"
                  class="w-100 mt-3"
                  style="margin-bottom: -2.5em; z-index: 1"
                >
                  <span
                    class="p-1 px-2 text-light"
                    style="
                      background-color: #f28d00;
                      font-size: 11px;
                      font-weight: 500;
                    "
                    >BETA</span
                  >
                </div>
                <div
                  v-if="item.additionalProp1.coming_soon"
                  class="w-100 mt-3"
                  style="margin-bottom: -2.5em; z-index: 1"
                >
                  <span
                    class="p-1 px-2 text-light"
                    style="
                      background-color: #333;
                      font-size: 11px;
                      font-weight: 500;
                    "
                    >COMING SOON</span
                  >
                </div>
                <div
                  v-if="item.additionalProp1.new"
                  class="w-100 mt-3"
                  style="margin-bottom: -2.5em; z-index: 1"
                >
                  <span
                    class="p-1 px-2 text-light"
                    style="
                      background-color: #b60000;
                      font-size: 11px;
                      font-weight: 500;
                    "
                    >NEW</span
                  >
                </div>
                <div class="card-body p-0">
                  <div class="text-primary font-size-50">
                    <span v-if="item.additionalProp1.icon">
                      <img
                        v-if="item.additionalProp1.icon.endsWith('.svg')"
                        :src="
                          require(`@/assets/images/${item.additionalProp1.icon}`)
                        "
                      />
                      <i v-else :class="item.additionalProp1.icon"></i>
                    </span>
                  </div>
                </div>
                <div class="card-body p-0 pb-3 pt-2 text-center">
                  <p class="mx-auto text-uppercase m-0 font-weight-medium">
                    {{
                      item.name === "Meeting & Events" ? "Events" :
                      item.name === "Partner Organisations" ? "Partner Org." :
                      item.name
                    }}
                  </p>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <div
        v-if="
          (this.currentPractice.name == 'Demo' ||
            this.currentPcn.name == 'BARNET 1W PCN' ||
            this.currentPcn.name == 'FLEET PCN' ||
            this.currentPcn.name == 'WINDSOR PCN') &&
          categoriesList.length &&
          isStaffCategory()
        "
      >
        <div class="font-size-20 font-weight-medium mt-4">PCN Updates</div>
        <div class="row p-0 mt-4" style="letter-spacing: 0.02em">
          <div
            class="col-md-2"
            v-for="item in categoriesList"
            v-bind:key="`${item.id}0`"
            :to="item.link"
            @click="updateCurrentCategory(item)"
            v-show="
              item.name == 'PCN News' ||
              item.name == 'PCN Mail Settings' ||
              item.name == 'PCN Insights' ||
              item.name == 'PCN Events' ||
              item.name == 'PCN Social Media' ||
              item.name == 'Alerts'
            "
          >
            <router-link
              :to="{
                name: 'Dynamic Network Category Page',
                params: {
                  categoryId: item.id,
                  cmsId: item.cmsId,
                  categoryName: item.name.replace(/ /g, '').toLowerCase(),
                },
              }"
              class="text-dark"
            >
              <div class="card align-items-center">
                <div
                  v-if="item.additionalProp1.beta"
                  class="w-100 mt-3"
                  style="margin-bottom: -2.5em; z-index: 1"
                >
                  <span
                    class="p-1 px-2 text-light"
                    style="
                      background-color: #f28d00;
                      font-size: 11px;
                      font-weight: 500;
                    "
                    >BETA</span
                  >
                </div>
                <div
                  class="w-100 mt-3"
                  style="margin-bottom: -2.5em; z-index: 1"
                >
                  <span
                    class="p-1 px-2 text-light"
                    style="
                      background-color: #333;
                      font-size: 11px;
                      font-weight: 500;
                    "
                    >COMING SOON</span
                  >
                </div>
                <div
                  v-if="item.additionalProp1.new"
                  class="w-100 mt-3"
                  style="margin-bottom: -2.5em; z-index: 1"
                >
                  <span
                    class="p-1 px-2 text-light"
                    style="
                      background-color: #b60000;
                      font-size: 11px;
                      font-weight: 500;
                    "
                    >NEW</span
                  >
                </div>
                <div class="card-body p-0">
                  <div class="text-primary font-size-50">
                    <span v-if="item.additionalProp1.icon">
                      <img
                        v-if="item.additionalProp1.icon.endsWith('.svg')"
                        :src="
                          require(`@/assets/images/${item.additionalProp1.icon}`)
                        "
                      />
                      <i v-else :class="item.additionalProp1.icon"></i>
                    </span>
                  </div>
                </div>
                <div class="card-body p-0 pb-3 pt-2 text-center">
                  <p class="mx-auto text-uppercase m-0 font-weight-medium">
                    {{
                      item.name === "Meeting & Events" ? "Events" :
                      item.name === "Partner Organisations" ? "Partner Org." :
                      item.name
                    }}
                  </p>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
